module.exports = __webpack_public_path__ + "media/images/app/tabbar-444cddbc61a871eee4939c084630b5ae.svg";